import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomerService } from 'src/app/admin/services/customer/customer.service';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { OrderServiceService } from 'src/app/admin/services/orders/order-service.service';

@Component({
  selector: 'app-guidance-orders',
  templateUrl: './guidance-orders.component.html',
  styleUrls: ['./guidance-orders.component.scss'],
  standalone: false
})
export class GuidanceOrdersComponent implements OnInit {


  constructor(
    private order: OrderServiceService,
    private guidanceService: GuidanceService,
    private spinner: NgxSpinnerService,
    private customerService: CustomerService
  ) { }
  title = 'angular-datatables';

  orderList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getAllOrderList()
    this.getCustomerList()
  }

  /* ***********
  list All Orders
  *********** */

  getAllOrderList() {
    this.spinner.show()
    this.guidanceService.getGuidanceOrders({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.orderList = res.data;
        this.temp = this.orderList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter((d: any) => {
      const customerName = d.customerId?.name?.toLowerCase() || '';
      const guidanceId = d.oGuidanceId?.toString() || '';
      const category = d.guidanceCategoryName?.toLowerCase() || '';
      const card = d.guidanceCardName?.toLowerCase() || '';
      const astroName = d.astroId?.name?.toLowerCase() || '';

      return (
        customerName.includes(val) ||
        guidanceId.includes(val) ||
        astroName.includes(val) ||
        category.includes(val) ||
        card.includes(val)
      );
    });

    this.orderList = temp;
    this.myFilterTable.offset = 0;
  }


  customerList: any = []
  getCustomerList() {
    this.customerService.getCustomersList({}).subscribe(
      (res: any) => {
        this.customerList = res.data
      }
    )
  }

  getOrderByCustomerId(event: any) {
    //console.log(event)
    if (event == "") {
      this.getAllOrderList()
    } else {
      this.spinner.show()
      this.order.getAllOrderList({ customerId: event }).subscribe(
        (res: any) => {
          this.spinner.hide()
          this.orderList = res.data;
          //console.log(this.orderList)
          this.temp = this.orderList;
        },
        (err) => {
          this.spinner.hide()
          //console.log(err);
        }
      );
    }
  }

  searchOrders(data: any) {
    this.spinner.show()
    this.order.getAllOrderList(data).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.orderList = res.data;
        //console.log(this.orderList)
        this.temp = this.orderList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  expandedRows: { [key: number]: boolean } = {};

  getPlainTextFromHTML(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  getFirstWords(html: string, wordLimit: number): string {
    const text = this.getPlainTextFromHTML(html);
    const words = text.split(/\s+/);
    return words.slice(0, wordLimit).join(' ') + (words.length > wordLimit ? '...' : '');
  }
}
